import { newsletter } from "@/app/actions/newsletter";
import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const schema = z.object({
  email: z
    .string({ message: "Por favor, preencha o campo." })
    .email({ message: "Por favor, insira um e-mail válido." }),
});

type TFormProps = z.infer<typeof schema>;

export function useCtaForm() {
  const [message, setMessage] = React.useState<string>("");

  const {
    control,
    reset,
    handleSubmit: hookFormSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<TFormProps>({
    resolver: zodResolver(schema),
  });

  const onSubmit = hookFormSubmit(async ({ email }) => {
    setMessage("");
    setError("email", { message: "" });

    const data = await newsletter(email);

    if (data.resultado === "Successo") {
      setMessage("E-mail cadastrado com sucesso!");
      reset();
    }

    if (data.resultado === "Erro" || data.statusCode === 500) {
      setError("email", { message: data.mensagem });
      return;
    }
  });

  return {
    errors,
    message,
    control,
    onSubmit,
    isSubmitting,
  };
}
